import { Component, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { TabStripComponent } from '@progress/kendo-angular-layout';
import { State, process } from '@progress/kendo-data-query';
import { GlobalService } from '../../_services/GlobalService';
import { TourneeViewComponent } from '../_Views/tournee-view/tournee-view.component';
import { Tournee } from '../../_models/Tournee';
import { TourneeService } from '../../_services/TourneeService';
import { PopupServiceConfirmerSuppressionTournee } from '../../_services/PopupServiceConfirmerSuppressionTournee';

@Component({
  selector: 'app-tournee-admin',
  templateUrl: './tournee-admin.component.html',
  styleUrls: ['./tournee-admin.component.scss']
})
export class TourneeAdminComponent {
  @ViewChild('dialogActions') dialogActions!: TemplateRef<unknown>;
  public dialog !: DialogRef;

  @ViewChild("detailTourneeContainer", { read: ViewContainerRef })
  public detailTourneeContainer!: ViewContainerRef;
  @ViewChild('tabstrip') ts!: TabStripComponent;
  public gridData!: GridDataResult;
  public gridState: State = {
    skip: 0,
    take: 50,

  };
  loading: boolean = false;
  public Tournees: Tournee[] = new Array()
  public AfficherTourneeArchive: boolean = false
  public selectedDate: Date = new Date();

  public constructor(private _TourneeService: TourneeService,
    public _GlobalService: GlobalService,
    private _dialogService: DialogService,
    private popupService: PopupServiceConfirmerSuppressionTournee) { }

  ngOnInit(): void {
    //charge le tableau des utilisateurs
    this.ChargerListeTournee();
  }

  public async ChargerListeTournee() {
    this.loading = true;

    this.Tournees = (await this._TourneeService.GetTourneesToday()).objet;

    //Filtrer par date
    this.Tournees = this.Tournees.sort((a, b) => { return a.date < b.date ? 1 : -1 })

    this.dataStateChange(this.gridState);
    this.loading = false;
  }

  public async dataStateChange(state: State) {
    this.gridState = state;
    await this.ChargerTableau();
  }
  ///charge les utilisateurs dans le tableau
  public async ChargerTableau() {

    //Affecter la bonne date aux tournées
    this.Tournees = this.Tournees.map(t => {
      return {
        ...t,
        date: new Date(t.date)
      };
    });

    // Init des données pour la grille
    this.gridData = process(this.Tournees, this.gridState);
  }

  public ouvreDetailTournee(Tournee: Tournee, nouveau: boolean) {
    this.dialog = this._dialogService.open({
      title: "Fiche de la tournée",
      width: '90%',
      height: '90%',
      //actions: [cancelAction, saveAction],
      actions: this.dialogActions,

      appendTo: this.detailTourneeContainer,
      closeTitle: "Fermer",
      content: TourneeViewComponent,
    });

    let DetailTournee = this.dialog.content.instance;
    DetailTournee.Tournee = Tournee;
    DetailTournee.nouveau = nouveau;
  }

  //ajouter un nouveau Tournee
  public AjouterTournee() {
    this.ouvreDetailTournee(new Tournee(), true);
  }

  //ferme la boite de dialogue
  public closeTournee(): void {
    if (this.dialog) {
      this.dialog.close();
    }
  }

  ModifierTournee({ dataItem }: any) {
    this.ouvreDetailTournee(dataItem as Tournee, false);
  }

  public async EnregistrerTournee() {

    let DetailClient = (this.dialog.content.instance as TourneeViewComponent);

    if (DetailClient.validate() && await DetailClient.EnregistrerTournee()) {

      this.loading = true;

      await this.ChargerListeTournee();

      this.closeTournee();

      this.loading = false;
    }

  }

  public async ExporterTournee(event: any) {
    this.loading = true;
    let reponse = await this._TourneeService.ImprimerTournee(event.id);

    if (reponse.statusCode == 200) {
      this.telechargerFichierExcel(reponse.objet, `Tournee_${event.id}`);
    } else {

    }
    this.loading = false;
  }

  public async SupprimerTournee(event: any) {
    this.popupService.showPopup(
      () => {
        this.popupService.closePopup()
      },
      async () => {
        this.loading = true;
        let reponse = await this._TourneeService.DeleteTournee(event.id);
        this.Tournees = this.Tournees.filter(x => x.id != event.id)
        this.ChargerTableau()
        this.loading = false;
      }
    );
  }

  private telechargerFichierExcel(base64Data: string, fileName: string) {
    // Décoder la base64 en un Blob
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    // Créer un lien pour le téléchargement
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `${fileName}.xlsx`; // Nom du fichier à télécharger
    link.click();

    // Libérer l'URL du Blob
    URL.revokeObjectURL(link.href);
  }

  async AfficherTourneeArchivee() {
    this.loading = true;
  
    // Réinitialiser le filtre de date
    this.selectedDate = null as any; // force null pour effacer le filtre
  
    if (this.AfficherTourneeArchive) {
      this.Tournees = (await this._TourneeService.GetTourneesToday()).objet;
    } else {
      this.Tournees = (await this._TourneeService.GetAllTournees()).objet;
    }
  
    this.ChargerTableau();
  
    this.loading = false;
  }

  public onDateFilterChange(date: Date): void {
    this.selectedDate = date;

    if (date) {
      // Filtrer les tournées avec la date exacte (ignorer l'heure)
      const jour = date.getDate();
      const mois = date.getMonth();
      const annee = date.getFullYear();

      const tournéesFiltrées = this.Tournees.filter(t =>
        t.date.getDate() === jour &&
        t.date.getMonth() === mois &&
        t.date.getFullYear() === annee
      );

      this.gridData = process(tournéesFiltrées, this.gridState);
    } else {
      // Si aucune date sélectionnée, restaurer toutes les tournées
      this.gridData = process(this.Tournees, this.gridState);
    }
  }


}
